
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/system",
      function () {
        return require("private-next-pages/solutions/system.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/system"])
      });
    }
  